import React from 'react';
import PropTypes from 'prop-types';

const WorksheetTitle = ({ title }) => (
  <h1 className="h1 regular m0 p3 py1">{title}</h1>
);

WorksheetTitle.defaultProps = {
  title: null,
};

WorksheetTitle.propTypes = {
  title: PropTypes.node,
};

export default WorksheetTitle;
